import { palette } from '@instamenu/ui-vanilla-extract';
import { InputHTMLAttributes, Ref } from 'react';

export const checkboxSize = 26;

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> & {
  value?: boolean;
  onChange: (v: boolean) => void;
  ref?: Ref<HTMLInputElement> | undefined;
};

export const Checkbox = (props: CheckboxProps) => {
  const { onChange, value, ref, ...rest } = props;
  return (
    <label
      style={{
        display: 'inline-block',
        cursor: 'pointer',
        position: 'relative',
        height: checkboxSize,
      }}
    >
      <input
        type="checkbox"
        ref={ref}
        style={{ display: 'none' }}
        checked={props.checked || value}
        onChange={(e) => onChange(e.currentTarget.checked)}
        {...rest}
      />
      <svg
        width={checkboxSize}
        height={checkboxSize}
        viewBox={`0 0 ${checkboxSize} ${checkboxSize}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width={checkboxSize - 2}
          height={checkboxSize - 2}
          stroke="#C5C4C4"
          strokeWidth="1"
          rx="2"
          ry="2"
        />
        {(props.checked || value) && (
          <path d="M5.5 12L10.5 17L19.5 7" strokeWidth={2} stroke={palette.primary} />
        )}
      </svg>
    </label>
  );
};
